import axios from "axios";
import ServiceHelper from "./serviceHelper";
import envConfig from "../config";

class AccountDataService {
  static GetBoardServiceClientData() {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .get(`${envConfig.apiBaseUrl}/api/accountdata/servicesummary`, config)
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
        return null;
      });
  }

  static GetAccountInfos() {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .get(`${envConfig.apiBaseUrl}/api/accountdata/accountinfos`, config)
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
        return null;
      });
  }

  static UpdateAccountReportInfos(accountReportInfos) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .post(
        `${envConfig.apiBaseUrl}/api/accountdata/accountreportinfos`,
        accountReportInfos,
        config,
      )
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
        return null;
      });
  }

  static UpdateAccountParameters(parameters) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .put(`${envConfig.apiBaseUrl}/api/accountdata/parameters`, parameters, config)
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);

        if (ok) return;

        return null;
      });
  }

  static GetCalendarData(clientExternalId, horseExternalId, userServiceExternalId) {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .post(
        `${envConfig.apiBaseUrl}/api/accountdata/calendar`,
        {
          clientExternalId,
          horseExternalId,
          userServiceExternalId,
        },
        config,
      )
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return;
        return null;
      });
  }
}

export default AccountDataService;
